var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9H5V11H7V9Z",
    fill: "#2C94AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H9V11H11V9Z",
    fill: "#2C94AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H13V11H15V9Z",
    fill: "#2C94AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9H17V11H19V9Z",
    fill: "#2C94AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13H5V15H7V13Z",
    fill: "#2C94AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H9V15H11V13Z",
    fill: "#2C94AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H13V15H15V13Z",
    fill: "#2C94AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H17V15H19V13Z",
    fill: "#2C94AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17H5V19H7V17Z",
    fill: "#2C94AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H9V19H11V17Z",
    fill: "#2C94AB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H13V19H15V17Z",
    fill: "#2C94AB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H17V19H19V17Z",
    fill: "#2C94AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 3H20V2.5C20 1.1 18.9 0 17.5 0C16.1 0 15 1.1 15 2.5V3H9V2.5C9 1.1 7.9 0 6.5 0C5.1 0 4 1.1 4 2.5V3H2.8C1.2 3 0 4.2 0 5.8V21.3C0 22.8 1.2 24 2.8 24H21.3C22.8 24 24.1 22.8 24.1 21.2V5.8C24 4.2 22.8 3 21.2 3ZM17 4.5V2.5C17 2.2 17.2 2 17.5 2C17.8 2 18 2.2 18 2.5V4.5C18 4.8 17.8 5 17.5 5C17.2 5 17 4.8 17 4.5ZM6 4.5V2.5C6 2.2 6.2 2 6.5 2C6.8 2 7 2.2 7 2.5V4.5C7 4.8 6.8 5 6.5 5C6.2 5 6 4.8 6 4.5ZM22 21.2C22 21.6 21.7 22 21.2 22H2.8C2.3 22 2 21.7 2 21.2V5.8C2 5.3 2.3 5 2.8 5H4.1C4.3 6.1 5.3 7 6.5 7C7.7 7 8.7 6.1 8.9 5H15C15.2 6.1 16.2 7 17.4 7C18.6 7 19.6 6.1 19.8 5H21.1C21.7 5 22 5.3 22 5.8V21.2Z",
    fill: "#2C94AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b2d7cf2eadd590265d101febecf1cf98.svg";
export { ForwardRef as ReactComponent };